import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "../../actions/middleware_actions";
import Logo from "../../assets/logo_only.png";
import Bluefin from "../../assets/bluefin.jpg";
import LogoText from "../../assets/noaaTitle.png";
import {
  login_request,
  vendor_software_version,
} from "../../constants/default_request";
import { mapLoginStateToProps } from "../../services/mapStateToProps";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import AccountSupport from "../AccountSupport";

function RememberChkbx() {
  const [checked, setChecked] = useState(true);
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          inputProps={{
            "aria-label": "checkbox",
          }}
          style={{
            color: "white",
          }}
        />
      }
      label="Remember Me"
      style={{
        color: "white",
      }}
    />
  );
}

function Login({ isAuthUser, login }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showAccountSupport, setShowAccountSupport] = useState(false);

  const submitForm = () => {
    const payload = login_request(username, password);

    login(payload, username, password);
    setUsername("");
    setPassword("");
  };

  const passwordKeyDown = (Event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (Event.key === "Enter") {
      Event.preventDefault();
      Event.stopPropagation();
      submitForm();
    }
  };

  const styles = {
    formBackground: {
      height: "109vh",
      backgroundImage: `url(${Bluefin})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
    },
    linkStyle: {
      color: "white",
      fontSize: ".6em",
    },
    logoStyle: {
      width: "33%",
      height: "33%",
      marginTop: "5px",
      marginLeft: "5px",
    },
    imgStyle: {
      width: "100%",
      height: "auto",
    },
    textWhite: {
      color: "white",
    },
    textSize: {
      fontSize: ".9em",
    },
    input: {
      backgroundColor: "white",
    },
  };

  if (isAuthUser) {
    return <Navigate to={`${process.env.PUBLIC_URL}/home`} replace={true} />;
  }

  if (showAccountSupport) {
    return <AccountSupport close={() => setShowAccountSupport(false)} />;
  }

  return (
    <form className="login-form" style={styles.formBackground}>
      <Box className="noaa-logo-container">
        <Grid
          container
          align="center"
          style={{ display: "block", justifyContent: "center" }}
        >
          <Grid item style={{ flexDirection: "row" }}>
            <img
              src={Logo}
              style={styles.logoStyle}
              alt="N O A A dot gov logo"
            />
          </Grid>
          <Grid item sm={12}>
            <img
              src={LogoText}
              style={styles.imgStyle}
              alt="N O A A Fisheries"
            />
          </Grid>
        </Grid>
      </Box>

      <Box mt={0} width="60%">
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid item xs={12} md={7}>
            <TextField
              label="UserName"
              variant="outlined"
              fullWidth
              InputProps={{ style: styles.input }}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <TextField
              label="Password"
              variant="outlined"
              fullWidth
              InputProps={{ style: styles.input }}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => passwordKeyDown(e)}
              size="small"
            />
          </Grid>
          <Grid item xs={12} align={"center"}>
            <RememberChkbx />
          </Grid>
        </Grid>
      </Box>
      <Box mt={0} width="60%">
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={12} md={7}>
            <Button
              variant="contained"
              style={styles.textSize}
              color="primary"
              fullWidth
              className="form-input"
              onClick={submitForm}
              size="small"
            >
              Log In
            </Button>
          </Grid>
          <Grid item xs={12} md={7}>
            <Button
              style={styles.textSize}
              variant="contained"
              color="primary"
              fullWidth
              className="form-input"
              size="small"
              onClick={() => setShowAccountSupport(true)}
            >
              Account Support & Help
            </Button>
          </Grid>
          <Grid item xs={12} md={7}>
            {
              // eslint-disable-next-line
              <h6 style={({ marginBottom: 0 }, styles.textWhite)}>
                This is a Federal computer system and is the property of the
                United States Government. It is for authorized use only. Users
                (authorized or unauthorized) have no explicit or implicit
                expectation of privacy.
              </h6>
            }
          </Grid>
          <Grid item xs={12} align="center">
            <h5 style={styles.textWhite}>
              Version: {vendor_software_version()}
            </h5>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}

export default connect(mapLoginStateToProps, { login })(Login);
